import React from 'react';
import { 
  Typography,
  Stack,
  Paper
} from '@mui/material';
import { EstimateCenterEditor, EstimateServiceDateEditor, EstimatePayerEditor, EstimateStayTypeEditor } from '../../fieldEditors';

export const BasicInformationSection: React.FC = () => {

  return (
    <Paper elevation={1} sx={{ p: 3, backgroundColor: '#f8fafc' }}>
      <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, color: '#1e293b' }}>
        Basic Information
      </Typography>
      <Stack direction={{ xs: 'column', md: 'row' }} spacing={3}>
        <EstimateCenterEditor />
        <EstimatePayerEditor />
        <EstimateServiceDateEditor />
        <EstimateStayTypeEditor />
      </Stack>
    </Paper>
  );
};